// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../schema/public';

import { gql } from '@apollo/client';
import { ErrorsFragmentDoc } from '../../../../../components/Auth/Login/useLogin/LoginMutation.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TonConnectAuthMutationVariables = Types.Exact<{
  input: Types.UserManagementTonConnectAuthenticateInput;
}>;


export type TonConnectAuthMutation = { __typename?: 'Mutation', userManagementTonConnectAuthenticate?: { __typename?: 'UserManagementTonConnectAuthenticatePayload', token?: string, deviceDataToken?: string, errors?: Array<{ __typename?: 'UserManagementError', message?: string, params?: Array<{ __typename?: 'UserManagementErrorParam', name?: string, value?: string }> }> } };


export const TonConnectAuthMutationDocument = /*#__PURE__*/ gql`
    mutation TonConnectAuthMutation($input: UserManagementTonConnectAuthenticateInput!) {
  userManagementTonConnectAuthenticate(input: $input) {
    token
    deviceDataToken
    errors {
      ...ErrorsFragment
    }
  }
}
    ${ErrorsFragmentDoc}`;
export type TonConnectAuthMutationMutationFn = Apollo.MutationFunction<TonConnectAuthMutation, TonConnectAuthMutationVariables>;
export function useTonConnectAuthMutation(baseOptions?: Apollo.MutationHookOptions<TonConnectAuthMutation, TonConnectAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TonConnectAuthMutation, TonConnectAuthMutationVariables>(TonConnectAuthMutationDocument, options);
      }
export type TonConnectAuthMutationHookResult = ReturnType<typeof useTonConnectAuthMutation>;
export type TonConnectAuthMutationMutationResult = Apollo.MutationResult<TonConnectAuthMutation>;
export type TonConnectAuthMutationMutationOptions = Apollo.BaseMutationOptions<TonConnectAuthMutation, TonConnectAuthMutationVariables>;